import { ReactNode, FC, useEffect } from "react"
import Navbar from "./Navbar"
import { useDispatch, useSelector } from "react-redux"
import { setOpenSidebar } from "../redux/slices/appSlice"
import { Box, styled } from "@mui/material"
import LinearLoader from "./Loader/LinearLoader"
import FullPageInitializer from "./Loader/FullPageInitializer"
import UsersAPI from "./../../api/users"

import UserAPI from "./../../api/user"
import AdminAPI from "./../../api/admin"
import { setUserPerms } from "./../redux/slices/rolesAndPermsSlice"
import { setInitializing } from "./../redux/slices/appSlice"
import { setAdminInfo, setCurrentUser } from "./../redux/slices/adminSlice"
import { clearLocalstorage, getTokenLocal } from "../../helper/utils"
import { useNavigate } from "react-router-dom"
import { useResponseHandle } from "../hooks"

interface LayoutProps {
  children: ReactNode
}

const userAPI = new UserAPI()
const usersAPI = new UsersAPI()
const adminAPI = new AdminAPI()

const LayoutWrapper = styled(Box)({
  // border: "1px solid red",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
})

const MainPageWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open?: any }>(({ open }) => ({
  // border: "1px solid red",
  flex: 1,
  marginLeft: open ? "246px" : "64px",
  transition: "all 0.2s ease-in-out",
  display: "flex",
  flexDirection: "column",
  minHeight: "90vh",
}))

const MainPage = styled(Box)({
  // border: "1px solid red",
  flex: 1,
})

const Layout: FC<LayoutProps> = ({ children }) => {
  const token: any = getTokenLocal()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const currentUser = useSelector((state: any) => state.admin.currentUser)
  const open = useSelector((state: any) => {
    return state.app.openSidebar
  })

  const isLoading = useSelector((state: any) => {
    return state.app.loading
  })

  const appData: any = useSelector((state: any) => {
    return state.app
  })

  const handleDrawerOpen = () => {
    dispatch(setOpenSidebar(true))
  }

  const handleDrawerClose = () => {
    dispatch(setOpenSidebar(false))
  }

  const updateCurrentUserStatus = async (uid: any) => {
    const response = await usersAPI.updateNewUserStatus(token, uid)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
    } else {
      clearLocalstorage()
      navigate("/auth")
    }
  }

  const fetchCurrentLoggedInUser = async () => {
    const response = await adminAPI.getAdminInfo(token)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        if (result?.data?.status == "invited") {
          const uid = result?.data?.uid

          await updateCurrentUserStatus(uid)
        }

        dispatch(setAdminInfo(response?.data))
        dispatch(setCurrentUser(result?.data))
        return result?.data
      }
    } else {
      clearLocalstorage()
      navigate("/auth")
    }
  }

  const fetchUserPermissions = async () => {
    dispatch(setInitializing(true))

    const userData = await fetchCurrentLoggedInUser()

    if (!userData) {
      navigate("/auth")
    }

    const userRole = userData?.role_id

    const response = await userAPI.getRolesAndPermissionsInfo(token)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let allPerms: any = []
        const allModules = result?.data?.filter(
          (item: any) => item?.role_id == userRole,
        )?.[0]?.modules

        allModules?.forEach((module: any) => {
          module?.permissions?.forEach((perm: any) => {
            if (perm?.is_assigned) {
              allPerms?.push(`${perm?.module_name}.${perm?.key}`)
            }
          })
        })

        dispatch(setUserPerms(allPerms))
      }
    } else {
      clearLocalstorage()
      navigate("/auth")
    }

    dispatch(setInitializing(false))
  }

  useEffect(() => {
    fetchUserPermissions()
  }, [])

  useEffect(() => {
    if (!currentUser || Object.keys(currentUser || {}).length === 0) return

    const userId = (currentUser as any)?.uid ?? (currentUser as any)?.id
    const firstName = (currentUser as any)?.first_name || ""
    const lastName = (currentUser as any)?.last_name || ""
    const name = `${firstName} ${lastName}`.trim()
    const email = (currentUser as any)?.email
    const role = (currentUser as any)?.role_display_name

    const groupList = (currentUser as any)?.group_list || []
    const group =
    Array.isArray(groupList) && groupList.length === 1
      ? groupList[0]
      : ""
    const heap = (window as any)?.heap
    heap?.identify?.(userId)
    heap?.addUserProperties?.({
      name,
      email,
      role,
      group,
    })
  }, [currentUser])
 

  return (
    <>
      {appData?.initializing ? (
        <FullPageInitializer />
      ) : (
        <LayoutWrapper>
          <Navbar
            handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose}
            open={open}
          />
          <MainPageWrapper open={open}>
            {isLoading ? <LinearLoader /> : null}
            <MainPage>{children}</MainPage>
          </MainPageWrapper>
        </LayoutWrapper>
      )}
    </>
  )
}

export default Layout
